import React, { useRef, useState, useEffect } from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { Box, ClickAwayListener, Popper, TextField, Typography } from '@mui/material';
import { colors } from '../../constants/colors';
import thLocale from "date-fns/locale/th";
import enLocale from "date-fns/locale/en-GB";
import { useTranslation } from "react-i18next";
import moment from 'moment';
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import HelperText from '../input/helperText';

export type TimeProps = {
    key?: string;
    heading?: string;
    required?: boolean;
    inputName?: string;
    headingAlign?: React.CSSProperties['textAlign'];
    label?: string;
    helperText?: string;
    placeholder?: string;
    inputHeight?: any;
    disabled?: boolean;
    onblur?: any;
    onfocus?: any;
    value?: any;
    allowClear?: boolean;
    dateFormat?: string;
    disabledTextField?: boolean;
    format?: string;
    onChange?: (time: any) => void;
    disableStartTime?: any;
    disableEndTime?: any;
    headingCustom?: React.ReactNode;
}

const TimePickerCustom: React.FC<TimeProps> = (props) => {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState<boolean>(false);
    const datePickerRef = useRef<any>(null);
    const helperTextRef = useRef<HTMLInputElement>(null);

    const parseTimeToDate = (value: any) => {
        if (!value) return null;
        if (value instanceof Date) return value;
        if (typeof value === "string") {
            // ถ้าเป็นรูปแบบ "11.20" ให้แปลงเป็น "11:20" ก่อน
            const normalized = value.replace(".", ":");
            const [hours, minutes] = normalized.split(":").map(Number);
            if (!isNaN(hours) && !isNaN(minutes)) {
                const now = new Date();
                now.setHours(hours, minutes, 0, 0);
                return now;
            }
        }
        return null;
    };
    const handleClosePopover = () => {
        setOpen(false);
    };

    const handleIconClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setOpen((prev) => !prev);
    };

    useEffect(() => {
        if (props.helperText && helperTextRef.current) {
            helperTextRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            helperTextRef.current.focus();
        }
    }, [props.helperText]);

    return (
        <div className="w-full relative">
            {props.heading && (
                <div className="flex pb-[3px] gap-x-2" style={{ textAlign: props.headingAlign || 'left' }}>
                    <Typography>{props.heading}</Typography>
                    {props.required && <span style={{ color: colors.red }}>*</span>}

                    {props.headingCustom}
                </div>
            )}
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "en" ? enLocale : thLocale}>
                <ClickAwayListener onClickAway={handleClosePopover}>
                    <Box ref={datePickerRef}>
                        <TimePicker
                            value={parseTimeToDate(props.value)}
                            onChange={(value) => {
                                props.onChange && props.onChange(moment(value).format("HH:mm"));
                            }}
                            onAccept={() => setOpen(false)}
                            minutesStep={1}
                            ampm={false}
                            disabled={props.disabled}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    placeholder={props.placeholder}
                                    // helperText={props.helperText}
                                    value={params.value}
                                    inputRef={params.inputRef} // <<< สำคัญมาก ต้องใช้ของ params.inputRef!!
                                    sx={{
                                        backgroundColor: colors.white,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: 2,
                                            height: 48,
                                            "&.Mui-disabled": {
                                                backgroundColor: colors.black_25,
                                                opacity: 0.5,
                                            },
                                        },
                                        '& .MuiOutlinedInput-input': {
                                            height: '100%',
                                            padding: '10px',
                                        },
                                        '& .MuiFormHelperText-root': {
                                            color: props.disabled ? 'gray' : 'red',
                                        },
                                    }}
                                />
                            )}
                            components={{
                                OpenPickerIcon: AccessTimeIcon,
                            }}
                        />

                        {props.helperText && <HelperText label={props.helperText} />}
                    </Box>
                </ClickAwayListener>
            </LocalizationProvider>
        </div>
    );
};

export default TimePickerCustom;
